(function($) {

	'use strict';

	var init = function() {

		openMenu();
        
	};

	var openMenu = function() {

		$('.header__burger').click(function() {
			$(this).toggleClass('active');
			$('.header__sub').toggleClass('active');
			$('.header__top').toggleClass('active');
			blockTop();
		});
	}

	var blockTop = function() {

		if($('body').hasClass('open') === false) {
			$('body').data('top', $(window).scrollTop());
			$('body').toggleClass('open');
			$('body').scrollTop($('body').data('top'));
		} else {
			$('body').toggleClass('open');
			$('html, body').scrollTop($('body').data('top'));
		}

	};

	$(document).ready(function() {
		init();
	});

})(jQuery);
